import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/auth-context";
import { ROUTE_PATHS } from "@/routing/domainRoutes";

export function PublicRoute({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Loading session...</div>;
  }

  if (user) {
    return <Navigate to={ROUTE_PATHS.dashboardLegacy} replace />;
  }

  return children;
}
